import fetch from 'unfetch';

const fetchPartyInfo = async (partyId) => {
	const url = `/api/partyInfo`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({ partyId: partyId }),
	});

	if (res.ok) {
		console.log(await res.json());
		return { status: 'succ', data: await res.json() };
	} else {
		console.log(await res.json());
		return { status: 'error' };
	}
};
export default fetchPartyInfo;
